import React, { useState } from "react";
import "../../styles/form.css";

const EstimateModal = ({ show, onClose }) => {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    address: "",
    service: "",
    notes: "",
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const next = () => setStep((s) => Math.min(s + 1, 3));
  const prev = () => setStep((s) => Math.max(s - 1, 1));

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch("https://formspree.io/f/xblojqdz", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(form),
    });

    if (response.ok) {
      setSubmitted(true);
    } else {
      alert("Something went wrong. Please try again.");
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      {submitted ? (
        <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl mx-auto p-10 text-center flex flex-col items-center">
          <h2 className="text-2xl font-bold text-green-700 mb-4">
            🎉 Estimate Request Sent!
          </h2>
          <p className="text-gray-700 max-w-md">
            Thanks for reaching out. We’ve received your request and will follow
            up with pricing shortly.
          </p>
          <button
            onClick={() => {
              setSubmitted(false);
              setStep(1);
              setForm({
                name: "",
                email: "",
                address: "",
                service: "",
                notes: "",
              });
              onClose();
            }}
            className="mt-6 bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
          >
            Go Back
          </button>
        </div>
      ) : (
        <div className="bg-white rounded-xl p-6 max-w-md w-full relative shadow-xl">
          <button onClick={onClose} className="absolute top-2 right-4 text-xl">
            ×
          </button>
          <h2 className="text-xl font-bold mb-4 text-green-700">
            Request an Estimate
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            {step === 1 && (
              <>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Name"
                  className="w-full p-3 border rounded"
                />
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="Email Address"
                  className="w-full p-3 border rounded"
                />
              </>
            )}

            {step === 2 && (
              <>
                <input
                  type="text"
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  required
                  placeholder="Property Address"
                  className="w-full p-3 border rounded"
                />
                <select
                  name="service"
                  value={form.service}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border rounded"
                >
                  <option value="">Select Service Type</option>
                  <option value="Lawn Maintenance">Lawn Maintenance</option>
                  <option value="Landscaping">Landscaping</option>
                  <option value="Irrigation">Irrigation</option>
                </select>
              </>
            )}

            {step === 3 && (
              <>
                <input type="hidden" name="name" value={form.name} />
                <input type="hidden" name="email" value={form.email} />
                <input type="hidden" name="address" value={form.address} />
                <input type="hidden" name="service" value={form.service} />
                <textarea
                  name="notes"
                  value={form.notes}
                  onChange={handleChange}
                  placeholder="Anything we should know? (Optional)"
                  className="w-full p-3 border rounded"
                  rows={3}
                />
                <button
                  type="submit"
                  className="bg-green-600 w-full py-2 text-white rounded hover:bg-green-700 transition"
                >
                  Get My Estimate
                </button>
              </>
            )}
          </form>

          <div className="flex justify-between mt-4">
            {step > 1 && (
              <button onClick={prev} className="text-sm text-gray-600">
                ← Back
              </button>
            )}
            {step < 3 && (
              <button onClick={next} className="text-sm text-green-700">
                Next →
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default EstimateModal;
